(function() {
    'use strict';

    const CONFIG = {
        popupId: 'productPopup',
        closeButtonId: 'closePopup',
        cookieName: 'medpro_popup_closed',
        cookieDays: 7,
        showDelay: 2000
    };

    const popup = document.getElementById(CONFIG.popupId);
    const closeButton = document.getElementById(CONFIG.closeButtonId);

    if (!popup || !closeButton) {
        console.error('Popup elements not found');
        return;
    }

    function setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }

    function getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    function showPopup() {
        popup.classList.add('active');
        document.body.style.overflow = 'hidden';
    }

    function hidePopup() {
        popup.classList.remove('active');
        document.body.style.overflow = '';
        setCookie(CONFIG.cookieName, 'true', CONFIG.cookieDays);
    }

    closeButton.addEventListener('click', function(e) {
        e.preventDefault();
        hidePopup();
    });

    popup.addEventListener('click', function(e) {
        if (e.target === popup) {
            hidePopup();
        }
    });

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && popup.classList.contains('active')) {
            hidePopup();
        }
    });

    function initPopup() {
        const popupClosed = getCookie(CONFIG.cookieName);
        if (!popupClosed) {
            setTimeout(function() {
                showPopup();
            }, CONFIG.showDelay);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initPopup);
    } else {
        initPopup();
    }

})();
